/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmIszrAgenda extends GContentBase<SeznamAdmIszrAgendaObj> {
        private seznamObj: SeznamAdmIszrAgendaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmIszrAgendaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmIszrAgendaNew",
                contentCaption: "jres:33000752", //RC 33000752 : Agendy ISZR
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{agenda}"
                },
                gridSettings: {
                    columnOrder: "agenda,ur_pri,nazev,poznamka,seznam_udaju,seznam_udaju_ros,s_prist_rob,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmIszrAgendaObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmIszrAgenda", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmIszrAgenda",
                newRecord: isNew,
                agenda: isNew == true ? null : data.agenda
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAgendoveRole: {
                    caption: "jres:33000761", //RC 33000761 : P�i�azen� agendov� role
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openSeznamAgendoveRole();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamAgendoveRole }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*", "actOpenSeznamAgendoveRole*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmIszrAgenda.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.agenda),
                nazev: data["nazev"]
            }
        }

        private openSeznamAgendoveRole() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmIszrRole", { agenda: activeRow.agenda }], { ID: "SeznamAdmIszrRole" })
        }
    }
}